// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import { serverUrlAuth } from '../../serverUrl';

// // Async thunks
// export const fetchArtisanAcceptedProjects = createAsyncThunk(
//   'projects/fetchArtisanAcceptedProjects',
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await serverUrlAuth.get('projects/accepted-projects/');
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// export const submitProgressUpdate = createAsyncThunk(
//   'projects/submitProgressUpdate',
//   async ({ projectId, formData }, { rejectWithValue }) => {
//     try {
//       const response = await serverUrlAuth.post(
//         `updates/project-updates/${projectId}/`,
//         formData,
        
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// const projectsSlice = createSlice({
//   name: 'projects',
//   initialState: {
//     projects: [],
//     selectedProjectForDetails: null,
//     selectedProjectForUpdate: null,
//     activeImage: 0,
//     showUpdateModal: false,
//     progressForm: {
//       progress: '',
//       note: '',
//       uploaded_images: [],
//     },
//     loading: false,
//     submitting: false,
//     error: null,
//   },
//   reducers: {
//     setSelectedProjectForDetails: (state, action) => {
//       state.selectedProjectForDetails = action.payload;
//     },
//     setSelectedProjectForUpdate: (state, action) => {
//       state.selectedProjectForUpdate = action.payload;
//     },
//     setActiveImage: (state, action) => {
//       state.activeImage = action.payload;
//     },
//     setShowUpdateModal: (state, action) => {
//       state.showUpdateModal = action.payload;
//     },
//     setProgressForm: (state, action) => {
//       state.progressForm = { ...state.progressForm, ...action.payload };
//     },
//     resetProgressForm: (state) => {
//       state.progressForm = {
//         progress: '',
//         note: '',
//         uploaded_images: [],
//       };
//     },
//     addUploadedImages: (state, action) => {
//       state.progressForm.uploaded_images = [
//         ...state.progressForm.uploaded_images,
//         ...action.payload,
//       ];
//     },
//     removeUploadedImage: (state, action) => {
//       state.progressForm.uploaded_images = state.progressForm.uploaded_images.filter(
//         (_, index) => index !== action.payload
//       );
//     },
//     clearUploadedImages: (state) => {
//       state.progressForm.uploaded_images = [];
//     },
//     clearError: (state) => {
//       state.error = null;
//     },
//     resetProjectsState: (state) => {
//       state.projects = [];
//       state.selectedProjectForDetails = null;
//       state.selectedProjectForUpdate = null;
//       state.activeImage = 0;
//       state.showUpdateModal = false;
//       state.progressForm = {
//         progress: '',
//         note: '',
//         uploaded_images: [],
//       };
//       state.loading = false;
//       state.submitting = false;
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       // Fetch projects
//       .addCase(fetchArtisanAcceptedProjects.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchArtisanAcceptedProjects.fulfilled, (state, action) => {
//         state.loading = false;
//         // state.projects = action.payload.map((p) => ({
//         //   id: p.id,
//         //   title: p.title,
//         //   client: p.client,
//         //   amount: parseFloat(p.budget) || 0,
//         //   status:
//         //     p.status === 'in-progress'
//         //       ? 'In Progress'
//         //       : p.status === 'completed'
//         //       ? 'Completed'
//         //       : 'Pending',
//         //   startDate: p.created_at,
//         //   deadline: p.deadline,
//         //   progress: p.status === 'completed' ? 100 : (p.progress ?? 0),

//         //   images: (p.images || []).map((img) => img.image),
//         //   description: p.description || '',
//         //   unread_updates: p.unread_updates ?? 0,
//         // }));
//         state.projects = action.payload.map((p) => ({
//           id: p.id,
//           title: p.title,
//           client: p.client,
//           amount: parseFloat(p.budget) || 0,
//           status:
//             p.status === 'in-progress'
//               ? 'In Progress'
//               : p.status === 'completed'
//               ? 'Completed'
//               : 'Pending',
//           startDate: p.created_at,
//           deadline: p.deadline,
//           progress: p.status === 'completed' ? 100 : (p.progress ?? 0),

//           images: (p.images || []).map((img) => img.image),
//           description: p.description || '',
//           unread_updates: p.unread_updates ?? 0,
//         }));
//       })
//       .addCase(fetchArtisanAcceptedProjects.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })
//       // Submit progress update
//       .addCase(submitProgressUpdate.pending, (state) => {
//         state.submitting = true;
//         state.error = null;
//       })
//       .addCase(submitProgressUpdate.fulfilled, (state) => {
//         state.submitting = false;
//         state.showUpdateModal = false;
//         state.selectedProjectForUpdate = null;
//         state.progressForm = {
//           progress: '',
//           note: '',
//           uploaded_images: [],
//         };
//       })
//       .addCase(submitProgressUpdate.rejected, (state, action) => {
//         state.submitting = false;
//         state.error = action.payload;
//       });
//   },
// });

// export const {
//   setSelectedProjectForDetails,
//   setSelectedProjectForUpdate,
//   setActiveImage,
//   setShowUpdateModal,
//   setProgressForm,
//   resetProgressForm,
//   addUploadedImages,
//   removeUploadedImage,
//   clearUploadedImages,
//   clearError,
//   resetProjectsState,
// } = projectsSlice.actions;

// export default projectsSlice.reducer;


import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { serverUrlAuth } from '../../serverUrl';

// ========== ASYNC THUNKS ==========

// Fetch artisan accepted projects
export const fetchArtisanAcceptedProjects = createAsyncThunk(
  'projects/fetchArtisanAcceptedProjects',
  async (_, { rejectWithValue }) => {
    try {
      const response = await serverUrlAuth.get('projects/accepted-projects/');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Submit progress update
export const submitProgressUpdate = createAsyncThunk(
  'projects/submitProgressUpdate',
  async ({ projectId, formData }, { rejectWithValue }) => {
    try {
      const response = await serverUrlAuth.post(
        `updates/project-updates/${projectId}/`,
        formData,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ========== HELPER FUNCTIONS ==========

// Get display status from raw status
const getDisplayStatus = (status) => {
  if (!status) return 'Pending';
  
  const statusMap = {
    'in-progress': 'In Progress',
    'in progress': 'In Progress',
    'completed': 'Completed',
    'awaiting-deposit-payment': 'Awaiting Deposit Payment',
    'awaiting deposit payment': 'Awaiting Deposit Payment',
    'awaiting-final-payment': 'Awaiting Final Payment',
    'awaiting final payment': 'Awaiting Final Payment',
    'payment pending': 'Payment Pending',
    'pending payment': 'Payment Pending',
    'open': 'Open',
    'pending': 'Pending',
    'awaiting artisan': 'Awaiting Artisan',
    'awaiting-artisan': 'Awaiting Artisan',
    'active': 'Active',
  };
  
  const lowerStatus = status.toLowerCase();
  return statusMap[lowerStatus] || status;
};

// Get status badge variant for Bootstrap
const getStatusBadgeVariant = (status) => {
  if (!status) return 'secondary';
  
  const statusMap = {
    'in-progress': 'warning',
    'in progress': 'warning',
    'completed': 'success',
    'awaiting-deposit-payment': 'info',
    'awaiting deposit payment': 'info',
    'awaiting-final-payment': 'primary',
    'awaiting final payment': 'primary',
    'payment pending': 'warning',
    'pending payment': 'warning',
    'open': 'secondary',
    'pending': 'secondary',
    'awaiting artisan': 'info',
    'awaiting-artisan': 'info',
    'active': 'success',
  };
  
  const lowerStatus = status.toLowerCase();
  return statusMap[lowerStatus] || 'secondary';
};

// Get status dot class for CSS
const getStatusDotClass = (status) => {
  if (!status) return 'unknown';
  
  const statusMap = {
    'in-progress': 'in-progress',
    'in progress': 'in-progress',
    'completed': 'completed',
    'awaiting-deposit-payment': 'awaiting-deposit',
    'awaiting deposit payment': 'awaiting-deposit',
    'awaiting-final-payment': 'awaiting-final',
    'awaiting final payment': 'awaiting-final',
    'payment pending': 'pending',
    'pending payment': 'pending',
    'open': 'open',
    'pending': 'pending',
    'awaiting artisan': 'awaiting-artisan',
    'awaiting-artisan': 'awaiting-artisan',
    'active': 'active',
  };
  
  const lowerStatus = status.toLowerCase();
  return statusMap[lowerStatus] || 'unknown';
};

// ========== SLICE ==========

const projectsSlice = createSlice({
  name: 'projects',
  initialState: {
    projects: [],
    selectedProjectForDetails: null,
    selectedProjectForUpdate: null,
    activeImage: 0,
    showUpdateModal: false,
    progressForm: {
      progress: '',
      note: '',
      uploaded_images: [],
    },
    loading: false,
    submitting: false,
    error: null,
  },
  reducers: {
    // Set selected project for details modal
    setSelectedProjectForDetails: (state, action) => {
      state.selectedProjectForDetails = action.payload;
    },
    
    // Set selected project for update modal
    setSelectedProjectForUpdate: (state, action) => {
      state.selectedProjectForUpdate = action.payload;
    },
    
    // Set active image index
    setActiveImage: (state, action) => {
      state.activeImage = action.payload;
    },
    
    // Show/hide update modal
    setShowUpdateModal: (state, action) => {
      state.showUpdateModal = action.payload;
    },
    
    // Update progress form data
    setProgressForm: (state, action) => {
      state.progressForm = { ...state.progressForm, ...action.payload };
    },
    
    // Reset progress form
    resetProgressForm: (state) => {
      state.progressForm = {
        progress: '',
        note: '',
        uploaded_images: [],
      };
    },
    
    // Add uploaded images to progress form
    addUploadedImages: (state, action) => {
      state.progressForm.uploaded_images = [
        ...state.progressForm.uploaded_images,
        ...action.payload,
      ];
    },
    
    // Remove uploaded image from progress form
    removeUploadedImage: (state, action) => {
      state.progressForm.uploaded_images = state.progressForm.uploaded_images.filter(
        (_, index) => index !== action.payload
      );
    },
    
    // Clear all uploaded images
    clearUploadedImages: (state) => {
      state.progressForm.uploaded_images = [];
    },
    
    // Clear error
    clearError: (state) => {
      state.error = null;
    },
    
    // Reset entire projects state
    resetProjectsState: (state) => {
      state.projects = [];
      state.selectedProjectForDetails = null;
      state.selectedProjectForUpdate = null;
      state.activeImage = 0;
      state.showUpdateModal = false;
      state.progressForm = {
        progress: '',
        note: '',
        uploaded_images: [],
      };
      state.loading = false;
      state.submitting = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ===== FETCH PROJECTS =====
      .addCase(fetchArtisanAcceptedProjects.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchArtisanAcceptedProjects.fulfilled, (state, action) => {
        state.loading = false;
        
        // ✅ FIXED: Keep the original status from the API
        // Instead of transforming status to 'Pending' for unknown statuses,
        // we keep the raw status and provide helper functions for display
        state.projects = action.payload.map((p) => ({
          id: p.id,
          title: p.title,
          description: p.description || '',
          client: p.client,
          budget: p.budget || '0',
          agreed_cost: p.agreed_cost || '0',
          amount: parseFloat(p.budget) || 0,
          status: p.status || 'pending', // Keep raw status
          displayStatus: getDisplayStatus(p.status), // Computed display status
          statusBadgeVariant: getStatusBadgeVariant(p.status), // For Bootstrap badges
          statusDotClass: getStatusDotClass(p.status), // For CSS dots
          startDate: p.created_at,
          deadline: p.deadline,
          progress: p.status?.toLowerCase() === 'completed' ? 100 : (p.progress ?? 0),
          images: (p.images || []).map((img) => img.image || img),
          location: p.location || '',
          date_of_completion: p.date_of_completion,
          created_at: p.created_at,
          updated_at: p.updated_at,
          unread_updates: p.unread_updates ?? 0,
          // Keep original data for reference
          original: p,
        }));
      })
      .addCase(fetchArtisanAcceptedProjects.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch projects';
      })
      
      // ===== SUBMIT PROGRESS UPDATE =====
      .addCase(submitProgressUpdate.pending, (state) => {
        state.submitting = true;
        state.error = null;
      })
      .addCase(submitProgressUpdate.fulfilled, (state, action) => {
        state.submitting = false;
        state.showUpdateModal = false;
        state.selectedProjectForUpdate = null;
        state.progressForm = {
          progress: '',
          note: '',
          uploaded_images: [],
        };
        
        // Update the project's progress in the list if it exists
        const updatedProject = action.payload;
        if (updatedProject && updatedProject.id) {
          const index = state.projects.findIndex(p => p.id === updatedProject.id);
          if (index !== -1) {
            state.projects[index] = {
              ...state.projects[index],
              progress: updatedProject.progress ?? state.projects[index].progress,
              status: updatedProject.status || state.projects[index].status,
              displayStatus: getDisplayStatus(updatedProject.status || state.projects[index].status),
              statusBadgeVariant: getStatusBadgeVariant(updatedProject.status || state.projects[index].status),
              statusDotClass: getStatusDotClass(updatedProject.status || state.projects[index].status),
              updated_at: updatedProject.updated_at,
            };
          }
        }
      })
      .addCase(submitProgressUpdate.rejected, (state, action) => {
        state.submitting = false;
        state.error = action.payload || 'Failed to submit progress update';
      });
  },
});

// ========== EXPORT ACTIONS ==========
export const {
  setSelectedProjectForDetails,
  setSelectedProjectForUpdate,
  setActiveImage,
  setShowUpdateModal,
  setProgressForm,
  resetProgressForm,
  addUploadedImages,
  removeUploadedImage,
  clearUploadedImages,
  clearError,
  resetProjectsState,
} = projectsSlice.actions;

// ========== EXPORT SELECTORS ==========
export const selectAllProjects = (state) => state.projects.projects;
export const selectSelectedProjectForDetails = (state) => state.projects.selectedProjectForDetails;
export const selectSelectedProjectForUpdate = (state) => state.projects.selectedProjectForUpdate;
export const selectProjectsLoading = (state) => state.projects.loading;
export const selectProjectsSubmitting = (state) => state.projects.submitting;
export const selectProjectsError = (state) => state.projects.error;
export const selectProgressForm = (state) => state.projects.progressForm;
export const selectShowUpdateModal = (state) => state.projects.showUpdateModal;
export const selectActiveImage = (state) => state.projects.activeImage;

// Helper selector to get projects by status
export const selectProjectsByStatus = (status) => (state) => {
  const projects = selectAllProjects(state);
  if (!status || status === 'All') return projects;
  return projects.filter(p => p.status?.toLowerCase() === status.toLowerCase());
};

// Helper selector to get projects by display status
export const selectProjectsByDisplayStatus = (displayStatus) => (state) => {
  const projects = selectAllProjects(state);
  if (!displayStatus || displayStatus === 'All') return projects;
  return projects.filter(p => p.displayStatus === displayStatus);
};

// Export helper functions for use in components
export const statusHelpers = {
  getDisplayStatus,
  getStatusBadgeVariant,
  getStatusDotClass,
};

export default projectsSlice.reducer;